// src/client/getApiErrorMessage.ts
function getApiErrorMessage(error) {
  const err = error;
  return err?.response?.data?.message ?? err?.message;
}

export {
  getApiErrorMessage
};
